import clsx from 'clsx';
import React from 'react';

interface CustomRadioProps {
  isSelected: boolean;
}

const CustomRadio = ({ isSelected }: CustomRadioProps) => {
  return (
    <span
      className={clsx(
        'relative mr-8 h-28 w-28 flex-none rounded-full border border-solid border-slate-200 bg-white after:block',
        {
          "after:absolute after:left-3 after:top-3 after:h-20 after:w-20 after:rounded-full after:bg-primary-red after:content-['']":
            isSelected,
        }
      )}
    ></span>
  );
};

export default CustomRadio;
